import { BankStatementsAvailabilityListResponse } from './useBankStatementsAvailabilityList.interface';

import collectiveApi from 'modules/common/collectiveApi';

/**
 * Fetches a list of bank statement availability from the API
 * @param params - Optional parameters for the request
 * @returns Promise that resolves to the bank statements availability list
 */
const fetchBankStatementsAvailabilityList = async (): Promise<BankStatementsAvailabilityListResponse> => {
    const { data } = await collectiveApi.get<BankStatementsAvailabilityListResponse>('/bank-statements/availability/');
    return data;
};

export default fetchBankStatementsAvailabilityList;
